import React from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { Option } from '@/common/types';

import { LAST_30_DAYS_KEY } from '../CardStatusReport.types';

const OPTIONS: Option[] = [
  {
    key: LAST_30_DAYS_KEY,
    title: 'Last 30 days',
  },
  {
    key: 'LAST_7_DAYS',
    title: 'Last 7 days',
  },
];

interface Props {
  testId?: string;
  value: OptionKey;
  disabled?: boolean;
  onChangeValue: (value: OptionKey) => void;
}
const CardStatusDateRangeSelector: React.FC<Props> = ({
  testId = 'card-status_date-range-selector',
  disabled,
  value,
  onChangeValue,
}) => {
  return (
    <SelectDropdown
      ellipsisMode
      testId={testId}
      disabled={disabled}
      activeTitle
      options={OPTIONS}
      singleMode
      value={value}
      onChange={onChangeValue}
      prefix="Date range"
      id="card-status_date-range-selector"
      name="card-status_date-range-selector"
    />
  );
};

export default CardStatusDateRangeSelector;
